import { useEffect, useRef } from "react";
import {
  ADSTERRA_NATIVE_BANNER_CONTAINER_ID,
  ADSTERRA_NATIVE_BANNER_ENABLED,
  ADSTERRA_NATIVE_BANNER_SCRIPT_URL,
} from "@/config/adsterra";

const SCRIPT_MARKER = "data-aran-adsterra-native-banner";
const PARKING_ID = "aran-adsterra-native-banner-parking";

export function loadAdsterraNativeBannerScriptOnce() {
  if (typeof document === "undefined") return null;

  const existing = document.querySelector(`script[${SCRIPT_MARKER}]`)
    || Array.from(document.scripts).find((script) => script.src === ADSTERRA_NATIVE_BANNER_SCRIPT_URL);
  if (existing) return existing;

  const script = document.createElement("script");
  script.async = true;
  script.setAttribute("data-cfasync", "false");
  script.setAttribute(SCRIPT_MARKER, "true");
  script.src = ADSTERRA_NATIVE_BANNER_SCRIPT_URL;
  document.head.appendChild(script);
  return script;
}

function getOrCreateContainer() {
  let container = document.getElementById(ADSTERRA_NATIVE_BANNER_CONTAINER_ID);
  if (!container) {
    container = document.createElement("div");
    container.id = ADSTERRA_NATIVE_BANNER_CONTAINER_ID;
  }
  return container;
}

function parkContainer(container) {
  let parking = document.getElementById(PARKING_ID);
  if (!parking) {
    parking = document.createElement("div");
    parking.id = PARKING_ID;
    parking.hidden = true;
    document.body.appendChild(parking);
  }
  container.hidden = true;
  container.setAttribute("aria-hidden", "true");
  parking.appendChild(container);
}

export function hasSufficientPublishedEditorialContent(article) {
  if (article?.status !== "published" || !article?.published_at || !Array.isArray(article?.content)) return false;
  const text = article.content.map((block) => [
    block?.text,
    block?.label,
    ...(Array.isArray(block?.items) ? block.items : []),
  ].filter((value) => typeof value === "string").join(" ")).join(" ");
  return text.replace(/\s/g, "").length >= 600;
}

export default function AdsterraNativeBanner() {
  const placeholderRef = useRef(null);

  useEffect(() => {
    if (!ADSTERRA_NATIVE_BANNER_ENABLED || !placeholderRef.current) return undefined;

    const container = getOrCreateContainer();
    container.hidden = false;
    container.removeAttribute("aria-hidden");
    placeholderRef.current.appendChild(container);
    loadAdsterraNativeBannerScriptOnce();

    return () => parkContainer(container);
  }, []);

  if (!ADSTERRA_NATIVE_BANNER_ENABLED) return null;

  return (
    <aside
      ref={placeholderRef}
      className="mx-auto my-10 w-full max-w-3xl overflow-hidden"
      aria-label="إعلان"
      data-testid="adsterra-native-banner"
    />
  );
}
